import Vue from 'vue';
import { SimulateRequestService } from '@bto-services/api/shared/simulate-request-service';


/**
 * @typedef {ReturnType<typeof getDefaultState>} SimulateState
 */

/**
 * Initializes the default state for the module
 */
function getDefaultState() {
  return {
    /**
     * Array of simulate data
     * @type {Array<any>}
     */
    simulateData: [],
    /**
     * Flag to prevent duplicate async calls
     * @type {boolean}
     */
    asyncSimulateFlag: false,
    /**
     * Flag to track loading state
     * @type {boolean}
     */
    loading: false,
  };
}

// Create reactive state
export const simulateStore = Vue.observable(getDefaultState());

/**
 * Update simulate data in the store
 * @param {Array<any>} data
 */
export function addSimulateData(data) {
  Vue.set(simulateStore, 'simulateData', data);
}

/**
 * Update the async simulation flag
 * @param {boolean} flag
 */
export function updateAsyncSimulateFlag(flag) {
  simulateStore.asyncSimulateFlag = flag;
}

/**
 * Update the loading state
 * @param {boolean} isLoading
 */
export function updateLoadingStatus(isLoading) {
  simulateStore.loading = isLoading;
}

/**
 * Fetch simulate data from the API
 * @param {{ sportId: number; oddTypeIdentifier: string }} params
 */
export async function getSimulateItems(params) {
  updateLoadingStatus(true);

  // Prevent duplicate async calls
  if (simulateStore.asyncSimulateFlag) {
    return;
  }

  const request = new SimulateRequestService();
  updateAsyncSimulateFlag(true);

  request.getParams.sportID = params.sportId;
  request.getParams.oddTypeIdentifier = params.oddTypeIdentifier;

  try {
   const response = await request.execute();
   const sData = response.data.reduce((acc, item) => {
      const { sid, otid, ...rest } = item;
      if (!acc[sid]) {
        acc[sid] = {};
      }
      if (!acc[sid][otid]) {
        acc[sid][otid] = [];
      }
      acc[sid][otid].push(rest);
      return acc;
    }, {});
    addSimulateData(sData);
  } catch (error) {
    console.error('Error fetching simulate items:', error);
  } finally {
    updateAsyncSimulateFlag(false);
    updateLoadingStatus(false);
  }
}

/**
 * Reset the simulate store to its default state
 */
export function resetSimulateStore() {
  Object.assign(simulateStore, getDefaultState());
}
